// import { useEffect, useState } from 'react'
// import axios from 'axios'
// import { useTranslation } from 'react-i18next'
import styles from '@/styles/ReviewButton.module.css'
import ReviewButton from './ReviewButton'
import ShareableLink from './SharableLink'

const GoogleReviews = () => {
  // const { t } = useTranslation()
  // const [reviews, setReviews] = useState([])
  // const [loading, setLoading] = useState(false)

  // useEffect(() => {
  //   const fetchReviews = async () => {
  //     setLoading(true)
  //     try {
  //       const response = await axios.get(
  //         '/api/google-maps-reviews?placeId=ChIJI3NgLcSlX0YRfB8Fk-wHLHc'
  //       )
  //       setReviews(response.data)
  //     } catch (error) {
  //       console.error('Error fetching reviews:', error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }

  //   fetchReviews()
  // }, [])
  // const StarIcon = ({ filled }) => (
  //   <span style={{ color: filled ? 'gold' : 'gray' }}>★</span>
  // )
  return (
    <div className={styles.reviewsWrapper}>
      {/* <h1 className={styles.reviewsHeader}>{t('Google Maps Reviews')}</h1>
      {loading ? (
        <p>Loading reviews...</p>
      ) : (
        <ul className={styles.reviewsContainer}>
          {reviews.map((review) => (
            <li key={review.author_name} className={styles.reviewsLists}>
              <p className={styles.reviewsName}>
                <strong className={styles.reviewsStrong}>
                  {review.author_name}
                </strong>
              </p>
              <p className={styles.reviewsText}>{review.text}</p>
              <div className={styles.reviewsStar}>
                (Rating:{' '}
                {[...Array(review.rating)].map((_, index) => (
                  <StarIcon key={index} filled />
                ))}
                {[...Array(5 - review.rating)].map((_, index) => (
                  <StarIcon key={index} />
                ))}
                )
              </div>
            </li>
          ))}
        </ul>
      )} */}
      <ReviewButton />
      <ShareableLink />
    </div>
  )
}
export default GoogleReviews
